import { Exclude, Expose, Type } from "class-transformer";
import {
  IsArray,
  IsDefined,
  IsInt,
  IsOptional,
  IsString,
} from "class-validator";

import { GField, GInputType, GObjectType } from "../graphql";

import { Position } from "./Position";
import { VehicleTypePriceFee } from "./VehicleTypePriceFee";

@GObjectType("OrderCustomLocation")
@GInputType("OrderCustomLocationInput")
@Exclude()
export class OrderCustomLocation {
  @GField()
  @IsString()
  @IsDefined()
  @Expose()
  public title: string;

  @GField()
  @IsDefined()
  @Expose()
  @Type(() => Position)
  public position: Position;

  @GField()
  @IsInt()
  @IsDefined()
  @Expose()
  public duration: number;

  @GField()
  @IsInt()
  @IsDefined()
  @Expose()
  public order: number;

  @GField({ nullable: true })
  @IsString()
  @IsOptional()
  @Expose()
  public countryId?: string;

  @GField()
  @IsInt()
  @IsDefined()
  @Expose()
  public waitingPrice: number;

  @GField()
  @IsInt()
  @IsDefined()
  @Expose()
  public waitingFee: number;

  @GField(() => [VehicleTypePriceFee])
  @IsArray()
  @IsDefined()
  @Expose()
  @Type(() => VehicleTypePriceFee)
  public vehicleTypesPricesFees: VehicleTypePriceFee[] = [];
}
